import CartAccessDeniedPage from './CartAccessDeniedPage'

export default CartAccessDeniedPage
// eslint-disable-next-line import/export
export * from './CartAccessDeniedPage'
